export enum GamblingSessionStatus {
    Inactive = 0,
    Active = 1,
    Expired = 2,
    Restricted = 3
}

export interface GamblingSessionUpdateData {
    readonly gamblingSessionId: string;
    readonly sessionStatus: GamblingSessionStatus;
    readonly sessionActivationTime?: number;
    readonly sessionTotalBets: number;
    readonly sessionTotalWins: number;
    readonly updateCounter?: number;
    readonly restrictionExpirationDate?: number;
}
